import styled from '@emotion/styled'

export const Li = styled.li``

export const Ul = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25em;
`
